import { useMemo } from 'react';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useCurrentUser } from '#src/app/shared/hooks/session';

import { useGuestInfo } from '../useGuestInfo';

type Result = ModelHookResult<{
	replacements: Record<string, string>;
}>;

export function useReplacements(): Result {
	const {
		data: { petition, chipInAmountLocalized },
	} = usePsfPromoteOrSharePageData();
	const user = useCurrentUser();
	const guestInfo = useGuestInfo();

	return {
		data: {
			replacements: useMemo(() => {
				return {
					promoter_count: petition.promotionStats.promoterCountLocalized,
					chip_in_amount_formatted: chipInAmountLocalized,
					number_additional_signatures_from_promotions: petition.promotionStats.signatureCountLocalized,
					preferredName: (user ? user.shortDisplayName : guestInfo?.shortDisplayName) || '',
				};
			}, [petition, user, chipInAmountLocalized, guestInfo]),
		},
	};
}
